<template>
  <div class="customer-case">
    <AppBar />
    <div class="page-content">
      <div class="page-canvas">
        <!-- <div class="page-background">
          <img :src="require('@/assets/customer/canvas.png')" alt="" />
        </div> -->
        <div class="por-container">
          <div class="page-info">
            <div class="page-info-title">
              客户案例
            </div>
            <div class="page-info-describe">
              为企业创造更大的价值，让客户感动
            </div>
          </div>
        </div>
      </div>
      <div class="classic-case-wrap">
        <div class="title">典型客户案例</div>
        <el-tabs v-model="classicCaseIndex" @tab-click="handleClick">
          <el-tab-pane
            v-for="(item, index) in classicCaseLabalList"
            :key="index"
            :label="item.title"
            :name="item.name"
          />
        </el-tabs>
        <div class="classic-case-centent">
          <div class="classic-case-List">
            <div
              v-for="(caseItem, caseIndex) in classicCaseList"
              :key="caseIndex"
              class="classic-case-item"
              @click="lookToCase(caseItem)"
            >
              <div class="companyImg">
                <img :src="caseItem.icon" alt="" class="item-img" />
              </div>
              <div class="case-item-content">
                <img :src="caseItem.logo" alt="" class="case-item-logo" />
                <div class="case-item-text-warp">
                  <div class="case-item-title">{{ caseItem.title }}</div>
                  <div class="case-item-type">{{ caseItem.summaryTitle }}</div>
                  <div class="case-item-describe">{{ caseItem.description }}</div>
                </div>
                <img :src="require('@/assets/customer/icon/quotes-left.png')" alt="" class="quotes-left" />
                <img :src="require('@/assets/customer/icon/quotes-right.png')" alt="" class="quotes-right" />
              </div>
            </div>
          </div>
          <div class="case-more-btn" @click="moreList">
            查看更多案例
          </div>
        </div>
      </div>
      <div class="enterprise-advertisement">
        <!-- <enterprise-advertisement /> -->

        <img
          :src="require('@/assets/home/enterprise-advertisement1.png')"
          alt=""
          srcset=""
          class="enterprise-advertisement1"
        />
        <div class="enterprise-advertisement-num">
          <div class="enterprise-advertisement-num-item">
            <div class="enterprise-advertisement-num-item-top">
              <div>10万+</div>
              <div>服务企业HR人数</div>
            </div>
            <div class="enterprise-advertisement-num-item-foot">
              <div>100万+</div>
              <div>HR线上线下培训赋能</div>
            </div>
          </div>
          <img :src="require('@/assets/home/enterprise-advertisement2.png')" alt="" srcset="" />
          <div class="enterprise-advertisement-num-item">
            <div class="enterprise-advertisement-num-item">
              <div class="enterprise-advertisement-num-item-top">
                <div>20亿+</div>
                <div>日处理数据条数</div>
              </div>
              <div class="enterprise-advertisement-num-item-foot">
                <div>30万+</div>
                <div>每年产生HR招聘行为数据</div>
              </div>
            </div>
          </div>
          <img :src="require('@/assets/home/enterprise-advertisement2.png')" alt="" srcset="" />
          <div class="enterprise-advertisement-num-item">
            <div class="enterprise-advertisement-num-item">
              <div class="enterprise-advertisement-num-item-top">
                <div>2000万+</div>
                <div>服务企业员工人数</div>
              </div>
              <div class="enterprise-advertisement-num-item-foot">
                <div>30万+</div>
                <div>协助企业人才盘点人数</div>
              </div>
            </div>
          </div>
        </div>
        <div class="get-product-advertisement-btn" @click="openBealter">
          获取产品演示
        </div>
        <div class="get-product-advertisement-phone">
          <img :src="require('@/assets/home/enterprise-advertisement3.png')" alt="" srcset="" />
          <span v-html="preSales"></span>、<span v-html="afterSales"></span>
        </div>
      </div>
    </div>
    <RightFixedgt />
    <FootWrap />
    <AltProduct ref="altProduct" />
    <ast ref="ast" />
  </div>
</template>

<script>
import { getColumnChild } from '@/api/column';
import { getContentList } from '@/api/content';
import { getVariableInfo } from '@/api/variable';
export default {
  name: 'CustomerCase',
  data () {
    return {
      classicCaseIndex: '1605405080163672064',
      index: 0,
      classicCaseLabalList: [
        {
          name: '1605405080163672064',
          title: '全部行业',
        },
      ],
      classicCaseList: [
        // {
        //   id: 0,
        //   title: '三和精华集团',
        //   type: '综合集团',
        //   describe: '三和精化集团是一家集科、工、贸一体化的科技集团，集团对广东三和化工科技有限公司等多间制造型企业的产品进行监制。',
        //   img: require('@/assets/customer/case/customer-img1.png'),
        //   logo: require('@/assets/customer/case/customor-logo1.png'),
        // },
        // [
        // ],
      ],
      pageNum: 1,
      load: false,
      preSales: '',
      afterSales: '',
    };
  },
  mounted() {
    this.getCaseLabalList();
    this.getVariable();
  },
  methods: {
    getCaseLabalList() {
      getColumnChild({ parentId: '1605405080163672064', }).then((res) => {
        const { result, } = res;
        for (var i = 0; i < result.length; i++) {
          this.classicCaseLabalList.push({
            name: result[i].id,
            title: result[i].name,
          });
        }
        const label = this.$route.params.label ? this.$route.params.label : '';
        if (label !== '') {
          var CaseLabel = this.classicCaseLabalList.find((i) => {
            return label === i.title;
          });
          var CaseLabelIndex = this.classicCaseLabalList.findIndex((i) => {
            return label === i.title;
          });
          this.classicCaseIndex = CaseLabel.name;
          this.index = CaseLabelIndex;
        } else {
          this.classicCaseIndex = '1605405080163672064';
          this.index = 0;
        }
        this.getCaseList();
      });
    },
    getCaseList() {
      if (this.index === 0) {
        var params = {
          columnId: this.classicCaseLabalList[this.index].name,
          pageNum: this.pageNum,
          pageSize: 6,
          cascade: true,
        };
        getContentList(params).then((res) => {
          const { result, } = res;
          this.classicCaseList = this.classicCaseList.concat(result.data);
          if (result.data.length < 6) {
            this.load = true;
          } else {
            this.load = false;
          }
        });
      } else {
        var data = {
          columnId: this.classicCaseLabalList[this.index].name,
          pageNum: this.pageNum,
          pageSize: 6,
        };
        getContentList(data).then((res) => {
          const { result, } = res;
          this.classicCaseList = this.classicCaseList.concat(result.data);
          this.load = false;
        });
      }
    },
    getVariable() {
      getVariableInfo({ label: 'Hotline', }).then((res) => {
        const { result, } = res;
        var doc = new DOMParser().parseFromString(result.content, 'text/html');
        this.preSales = doc.documentElement.textContent.replace(/&nbsp;/g, ' ');
      })
      getVariableInfo({ label: 'afterSales', }).then((res) => {
        const { result, } = res;
        var doc = new DOMParser().parseFromString(result.content, 'text/html');
        this.afterSales = doc.documentElement.textContent.replace(/&nbsp;/g, ' ');
      })
    },
    handleClick (e) {
      this.index = Number(e.index);
      this.classicCaseList = [];
      this.pageNum = 1;
      this.load = true;
      this.getCaseList();
    },
    moreList() {
      if (!this.load) {
        this.pageNum += 1;
        this.load = true;
        this.getCaseList();
      }
    },
    lookToCase (caseItem) {
      this.$router.push({ path: `/caseindex/${caseItem.id}`, });
    },
    openBealter () {
      this.$refs.altProduct.tobealter();
    },
    openBealter2() {
       this.$refs.ast.drawer  = true
    },
  },
};
</script>

<style lang="less">
.get-product-advertisement-phone{
  p{
    display: inline-block;
  }
}
</style>
<style lang="less" scoped>
.customer-case{
    background-color: #fff;
    .page-content{
        width: 100%;
        .page-canvas{
            width: 100%;
            height: 360px;
            min-width: var(--minwidth);
            // position: relative;
            background: url('@/assets/customer/canvas.png') no-repeat;
            background-size: cover;
            background-position: center;
            .por-container{
                width: 70%;
                min-width: var(--minwidth);
                margin: 0 auto;
                position: relative;
                .page-info{
                    width: 40%;
                    height: 100%;
                    display: flex;
                    justify-content: center;
                    flex-direction: column;
                    padding-top: 119px;
                    box-sizing: border-box;
                    .page-info-title{
                        color: #fff;
                        font-size: 36px;
                        font-weight: 300;
                        line-height: 1;
                        margin-bottom: 30px;
                    }
                    .page-info-describe{
                        color: #fff;
                        font-size: 20px;
                        font-weight: 300;
                        line-height: 1;
                    }
                }
            }
        }
        .classic-case-wrap{
            width: 1200px;
            margin: 70px auto 60px;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: flex-start;
            .title{
                font-size: 32px;
                font-weight: 1;
                color: #181818;
                margin-bottom: 60px;
            }
            .classic-case-centent{
                width: 100%;
                display: flex;
                flex-direction: column;
                align-items: center;
                .classic-case-List{
                    width: 100%;
                    display: flex;
                    flex-wrap: wrap;
                    margin-bottom: 25px;
                    .classic-case-item{
                        width: 386px;
                        height: 445px;
                        background-color: #fff;
                        box-sizing: border-box;
                        border: solid 1px #dfdfdf;
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                        justify-content: flex-start;
                        margin: 10px 7px;
                        cursor: pointer;
                        .companyImg{
                          width: 100%;
                          height: 140px;
                          .item-img{
                              width: 100%;
                              height: 100%;
                              object-fit: cover;
                              object-position: center center;
                              display: block;
                          }
                        }
                        .case-item-content{
                            width: 100%;
                            flex: 1;
                            padding: 20px 30px;
                            box-sizing: border-box;
                            position: relative;
                            display: flex;
                            flex-direction: column;
                            align-items: center;
                            .case-item-logo{
                                width: auto;
                                height: 50px;
                                margin-bottom: 30px;
                            }
                            .case-item-text-warp{
                                width: 100%;
                                z-index: 1;
                                position: relative;
                                display: flex;
                                flex-direction: column;
                                align-items: flex-start;
                                .case-item-title{
                                    font-size: 18px;
                                    line-height: 1;
                                    color: #363f4e;
                                }
                                .case-item-type{
                                    font-size: 15px;
                                    line-height: 1;
                                    color: #363f4e;
                                    margin: 19px 0 13px 0;
                                }
                                .case-item-describe{
                                    width: 100%;
                                    font-size: 15px;
                                    line-height: 26px;
                                    color: #737c8b;
                                    overflow: hidden;
                                    text-overflow: ellipsis;
                                    word-break: break-all;
                                    display: -webkit-box;
                                    -webkit-box-orient: vertical;
                                    -webkit-line-clamp: 3;
                                }
                            }
                            .quotes-left{
                                width: 52px;
                                height: auto;
                                z-index: 0;
                                position: absolute;
                                left: 0;
                                bottom: 102px;
                                display: block;
                            }
                            .quotes-right{
                                width: 52px;
                                height: auto;
                                z-index: 0;
                                position: absolute;
                                right: 0;
                                bottom: 45px;
                                display: block;
                            }
                        }
                    }
                    .classic-case-item:hover{
                        width: calc(33.33% - 8px);
                        height: 452px;
                        box-shadow: 0px 4px 8px 0px rgba(139, 139, 139, 0.18);
                        margin: 6.5px 4px;
                        .case-item-content{
                            padding: 20.4px 30.5px;
                            .case-item-logo{
                                height: 51px;
                                margin-bottom: 30.5px;
                            }
                            .case-item-text-warp{
                                .case-item-title{
                                    font-size: 18.3px;
                                }
                                .case-item-type{
                                    font-size: 15.24px;
                                    margin: 19.3px 0 13.2px 0;
                                }
                                .case-item-describe{
                                    font-size: 15.3px;
                                    line-height: 26.4px;
                                }
                            }
                            .quotes-left{
                                width: 53px;
                            }
                            .quotes-right{
                                width: 53px;
                            }
                        }
                    }
                }
                .case-more-btn{
                    width: 155px;
                    height: 50px;
                    background-color: #fff;
                    border-radius: 25px;
                    border: 1px solid #00b0dc;
                    color: #00b0dc;
                    font-size: 15px;
                    line-height: 50px;
                    text-align: center;
                    cursor: pointer;
                }
            }
            ::v-deep .el-tabs{
                width: 100%;
                .el-tabs__header{
                    margin: 0 0 10px;
                    .el-tabs__nav-scroll{
                        display: flex;
                        justify-content: flex-start;
                        .el-tabs__active-bar{
                          background-color: #00b0dc;
                        }
                        .el-tabs__item:hover{
                          color: #00b0dc;
                        }
                        .is-active{
                          color: #00b0dc;
                        }
                        .el-tabs__item{
                            padding: 0 32px;
                            color: #4e5969;
                            font-size: 18px;
                        }
                    }
                }
            }
        }
        .enterprise-advertisement{
            width: 100%;
            min-width: var(--minwidth);
            height: 450px;
            margin-top: 60px;
            background-image: url('@/assets/home/enterprise-advertisement.png');
            background-size: cover;
            background-repeat: no-repeat;
            background-position: center;
            box-sizing: border-box;
            padding-top: 43px;
            // background: #2979ff;
            .enterprise-advertisement1{
            width: 612px;
            height: 39px;
            display: block;
            margin: 0px auto 49px;
            box-sizing: border-box;
            }
            .enterprise-advertisement-num{
                display: flex;
                justify-content: center;
                .enterprise-advertisement-num-item{
                width: 409px;
                // border: 1px solid;
                text-align: center;
                .enterprise-advertisement-num-item-top,
                .enterprise-advertisement-num-item-foot
                {
                    div:first-child{
                    font-size: 36px;
                    font-weight: normal;
                    font-style: italic;
                    font-stretch: normal;
                    line-height: 32px;
                    letter-spacing: 0px;
                    color: #f6f9fc;
                    font-weight: 600;
                    margin-bottom: 19px;
                    }
                    div:last-child{
                    font-size: 16px;
                    font-weight: normal;
                    font-stretch: normal;
                    line-height: 32px;
                    letter-spacing: 0px;
                    color: #f6f9fc;
                    opacity: 0.9;
                    }
                }
                .enterprise-advertisement-num-item-top{
                    margin-bottom: 30px;
                }
                }
            }
            .get-product-advertisement-btn{
            margin: 20px auto 10px;
            width: 242px;
            height: 46px;
            background-color: #ffffff;
            border-radius: 23px;
            font-size: 18px;
            font-weight: bold;
            font-stretch: normal;
            line-height: 32px;
            letter-spacing: 1px;
            color: #00b0dc;
            text-align: center;
            line-height: 46px;
            cursor: pointer;
            transition:  all .5s linear;
            user-select: none;
            &:hover{
                border-radius: 10px;
                background: #00b0dc;
                color: #fff;
            }
            }
            .get-product-advertisement-phone{
            width: 305px;
            margin: auto;
            color: #fff;
            img{
                width: 14px;
                height: 14px;
                margin: 0 8px 0 0;
            }
            }
        }
    }
}
</style>
